<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M7.414 26h3.479a1 1 0 110 2H5.167A1.167 1.167 0 014 26.833v-5.726a1 1 0 012 0v3.479l5.412-5.413a1 1 0 011.415 1.415L7.414 26zM6 7.414v3.479a1 1 0 11-2 0V5.167C4 4.522 4.522 4 5.167 4h5.726a1 1 0 110 2h-3.48l5.413 5.412a1 1 0 01-1.415 1.415L6 7.414zM24.586 6h-3.479a1 1 0 010-2h5.726C27.478 4 28 4.522 28 5.167v5.726a1 1 0 11-2 0V7.414l-5.412 5.413a1 1 0 01-1.415-1.415L24.586 6zm0 20h-3.479a1 1 0 000 2h5.726c.645 0 1.167-.522 1.167-1.167v-5.726a1 1 0 00-2 0v3.479l-5.412-5.413a1 1 0 00-1.415 1.415L24.586 26z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'arrowsArrowsOutOutline'
}
</script>
